// src/Objects/inkBottleData.js

import ink1 from "../assets/inkbottle/IMG-20250827-WA0019.jpg";
import ink2 from "../assets/inkbottle/IMG-20250827-WA0020.jpg";
import ink3 from "../assets/inkbottle/IMG-20250827-WA0021.jpg";
import ink4 from "../assets/inkbottle/IMG-20250827-WA0022.jpg";

const inkBottleData = [
  {
    id: 1,
    name: "Green Ink",
    description: "High-quality ink bottle suitable for all stamp types.",
    category: "Ink",
    image: ink1,
     size: "28ml",
  },
  {
    id: 2,
    name: "Red Ink",
    description: "Premium long-lasting ink bottle for stamps.",
    category: "Ink",
    image: ink2,
     size: "28ml",
  },
  {
    id: 3,
    name: "Black Ink",
    description: "Durable and vibrant ink bottle for professional use.",
    category: "Ink",
    image: ink3,
    size: "28ml",
  },
  {
    id: 4,
    name: "Blue Ink",
    description: "Reliable ink bottle available in multiple colors.",
    category: "Ink",
    image: ink4,
     size: "28ml",
  },
];

export default inkBottleData;
